export default class AssetTypeActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static VIEW_DATA_IN='VIEW_DATA_IN';
  static VIEW_DATA_OUT='VIEW_DATA_OUT';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_ASSET_TYPE='GET_HELPER_ASSET_TYPE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static VOID_DATA="VOID_DATA";

  static submit(){
    return {
      type: AssetTypeActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: AssetTypeActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: AssetTypeActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: AssetTypeActions.VIEW_DATA,
      payload: data
    };
  }

  static viewDataIn(dataIn) {
    return {
      type: AssetTypeActions.VIEW_DATA_IN,
      payload: dataIn
    };
  }

  static viewDataOut(dataOut) {
    return {
      type: AssetTypeActions.VIEW_DATA_OUT,
      payload: dataOut
    };
  }

  static delete(data) {
    return {
      type: AssetTypeActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: AssetTypeActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: AssetTypeActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: AssetTypeActions.SUCCESS_DATA,
    };
  }
  static void(data) {
    return {
      type: AssetTypeActions.VOID_DATA,
      payload: data
    };
    
  }
  static process(){
    return {
      type: AssetTypeActions.PROCESS_DATA,
    };
  }
  static resetList(){
    return {
      type: AssetTypeActions.RESET_LIST,
    };
  }
  static reset(){
    return {
      type: AssetTypeActions.RESET_DATA,
    };
  }
  static helper(helperAssetType){
    return {
      type: AssetTypeActions.GET_HELPER_ASSET_TYPE,
      payload:helperAssetType
    };
  }
  
  static errorInternal(error){
    return {
      type: AssetTypeActions.ERROR_SERVER,
      payload: error
    };
  }
}